<template>
  <b-modal
    id="modalSearch"
    hide-footer
    hide-header
    hide-actions
    size="md"
    centered
  >
    <div class="c-modal-search p-4">
      <div class="container">
        <div class="">
          <div class="d-flex justify-content-end">
            <button
              class="c-button c-button--x"
              @click="$bvModal.hide('modalSearch')"
            >
              <Icon icon="bi:x" class="h-100 w-100"/>
            </button>
          </div>
          <div class="c-form-group">
            <div class="d-flex justify-content-center mb-4">
              <input
                v-model="word"
                type="text"
                class="c-form-group__input"
                placeholder="¿Qué deseas aprender hoy?"
                @keyup.delete="clean()"
                @keyup.enter="search()"
              />
              <button @click="search()" class="c-button c-button--search">
                <span class="d-flex justify-content-center">
                  <Icon icon="ph:magnifying-glass-light" class="d-flex"/>
                </span>
              </button>
            </div>
          </div>
          <div>
            <b-skeleton-wrapper :loading="isLoading">
              <template #loading>
                <b-skeleton height="30px" class="mb-4"></b-skeleton>
                <b-skeleton height="30px" class="mb-4"></b-skeleton>
                <b-skeleton height="30px" class="mb-4"></b-skeleton>
                <b-skeleton height="30px" class="mb-4"></b-skeleton>
                <b-skeleton height="30px"></b-skeleton>
              </template>

              <template v-if="!result.empty">
                <div class="mb-4">
                  <ul class="ul-reset">
                    <li
                      v-for="course of result.data"
                      :key="`course-${course.id}`"
                      class="c-modal-search__li my-1"
                    >
                      <a
                        :href="`/curso/${course.slug}`"
                        @click.prevent="goToCourse(course)"
                        class="c-modal-search__a"
                      >
                        {{course.post_title}}
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="text-center">
                  <template v-if="isLoadingMore">
                    <div class="d-flex align-items-center justify-content-center">
                      <Icon icon="eos-icons:loading" class="me-1" />
                      Cargando...
                    </div>
                  </template>
                  <template v-else>
                    <a
                      v-if="result.data.length < result.total"
                      href=""
                      @click.prevent="search(true)"
                      class="c-link c-link--primary"
                    >
                      Cargar más resultados
                    </a>
                  </template>
                </div>
              </template>
              <template v-else>
                <p class="text-center">No hay resultados 😥, intente otra busqueda</p>
              </template>
            </b-skeleton-wrapper>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      word: '',

      result: {
        paged: 1,
        total: 0,

        data: [],
        empty: false,
      },

      isLoading: false,
      isLoadingMore: false,
    };
  },
  methods: {
    search(more = false) {
      if (this.word) {
        if (!more) {
          this.clean(true);
          this.isLoading = true;
        } else {
          this.isLoadingMore = true;
        }

        const request = `${process.env.VUE_APP_API}/courses/search?word=${this.word}&paged=${this.result.paged}`;

        fetch(request)
          .then((res) => {
            if (res.status === 201 || res.status < 300) {
              return res.json();
            }

            return res.text().then((text) => { throw new Error(text); });
          })
          .then((response) => {
            if (response.status) {
              this.result.data = this.result.data.concat(response.data.courses);
              this.result.empty = false;

              this.result.paged += 1;
              this.result.total = response.data.pagination.total;
            } else {
              this.result.empty = true;
            }
          })
          .catch((error) => {
            let errorMessage = '';

            try {
              errorMessage = JSON.parse(error.message)?.message;
            } catch (err) {
              errorMessage = error.message;
            }

            console.error(errorMessage);
          })
          .finally(() => {
            this.isLoading = false;
            this.isLoadingMore = false;
          });
      }
    },
    goToCourse(course) {
      this.$bvModal.hide('modalSearch');

      this.$router.push({ path: `/curso/${course.slug}` }).catch(() => {});
    },

    clean(purge = false) {
      if (!this.word) {
        this.result = {
          paged: 1,
          data: [],
          empty: false,
        };
      }

      if (purge) {
        this.result = {
          paged: 1,
          data: [],
          empty: false,
        };
      }
    },
  },
};
</script>
